import React, { FC } from 'react';
import { Outlet } from 'react-router';

const ResultsAndActivities: FC = () => {
  return <Outlet />;
};
export default ResultsAndActivities;
